import { XSVisualCardWidget } from '@leagueplatform/masonry-widgets';
import {
  ParagraphText,
  StatusBanner,
  Box,
  Icon,
} from '@leagueplatform/genesis-core';
import { isExternalUrl } from '@leagueplatform/web-common';

type XSVisualCardWidgetProps = Parameters<typeof XSVisualCardWidget>[0];

// Banner-style cards have body copy but no link; clickable tiles are the inverse.
const isBannerShape = ({
  actionLink,
  body,
}: XSVisualCardWidgetProps): boolean => Boolean(body) && !actionLink;

export const ScfhpXSVisualCardRenderer = (props: XSVisualCardWidgetProps) => {
  if (isBannerShape(props)) {
    const { heading, body } = props;
    return (
      <StatusBanner status="warning" title={heading}>
        <ParagraphText
          css={{ margin: '$half 0' }}
          htmlStringOptions={{
            a: {
              component: 'a',
              props: { target: '_blank', rel: 'noopener noreferrer' },
            },
          }}
        >
          {body ?? ''}
        </ParagraphText>
      </StatusBanner>
    );
  }

  const { actionLink } = props;

  if (!actionLink) {
    return <XSVisualCardWidget {...props} />;
  }

  const isExternal =
    isExternalUrl(actionLink) || actionLink.includes('link=sso');

  return (
    <Box
      css={{
        position: 'relative',
        display: 'flex',
        width: '100%',
        '& > *:first-child': { paddingInlineEnd: '$three' },
      }}
    >
      <XSVisualCardWidget {...props} />
      <Icon
        icon={isExternal ? 'interfaceExternalLink' : 'interfaceChevronRight'}
        size="$one"
        aria-hidden
        css={{
          position: 'absolute',
          insetInlineEnd: '$oneAndHalf',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: '$onSurfaceIconPrimary',
        }}
      />
    </Box>
  );
};
